import React from "react";

const PageLoader = () => {
    return (
        <>
            <style>{`
        .loader-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255,255,255,0.85);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 100;
        }

        .pulse-ring {
          width: 80px;
          height: 80px;
          border: 4px solid #4CAF50;
          border-radius: 50%;
          position: absolute;
          animation: pulse 1.5s ease-out infinite;
        }

        .pulse-ring.delay { animation-delay: 0.5s; }
        .pulse-ring.delay2 { animation-delay: 1s; }

        @keyframes pulse {
          0% { transform: scale(0.3); opacity: 1; }
          100% { transform: scale(1.5); opacity: 0; }
        }

        .loader-text {
          margin-top: 90px;
          font-weight: bold;
        }
      `}</style>

            <div className="loader-overlay">
                <div>
                    <div className="pulse-ring"></div>
                    <div className="pulse-ring delay"></div>
                    <div className="pulse-ring delay2"></div>
                    <h4 className="loader-text">Loading...</h4>
                </div>
            </div>
        </>
    );
};

export default PageLoader;